<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 16:35:14
 * @LastEditTime: 2020-07-16 14:52:33
 * @Description: 生成试卷
 -->
<template>
  <div class="generate-test-paper">
    <generate-test-paper-data-table />
    <generate-test-paper-setting :exam-id="examId" />
  </div>
</template>

<script>
import GenerateTestPaperDataTable from './GenerateTestPaperDataTable.vue';
import GenerateTestPaperSetting from './GenerateTestPaperSetting.vue';

export default {
  name: 'GenerateTestPaper',
  components: {
    GenerateTestPaperDataTable,
    GenerateTestPaperSetting,
  },
  props: {
    examId: { type: [Number, String], required: false },
  },
};
</script>

<style lang="less" scoped>
.generate-test-paper {
  width: 86%;
}
</style>
